import { TWS_API_URL } from "../../environment/apis.config";
import { getAccessToken } from "../../utils/auth.util";

export const fetchUserThresholds = async () => {
    try {
      const token = await getAccessToken();
      const response = await fetch(TWS_API_URL+'/customthreshold', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({}),
      });
  
      if (!response.ok) {
        throw new Error('Network response was not ok');
      }
  
      const data = await response.json();
      if(data["createdAt"]){
        delete data["createdAt"]
      }
      if(data["updatedAt"]){
        delete data["updatedAt"]
      }
      return data;
    } catch (error) {
      throw new Error('Error fetching user thresholds');
    }
};
  
export const updateThreshold = async (parameterName:string, updatedThreshold:any) => {
  try {
    const token = await getAccessToken();
    const response = await fetch(TWS_API_URL+'/customthreshold', {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify({ [parameterName]: updatedThreshold[parameterName] }),
    });

    if (!response.ok) {
      throw new Error('Network response was not ok');
    }

    const updatedData = await response.json();
    return updatedData;
  } catch (error) {
    throw new Error('Error updating user thresholds');
  }
};

export const deleteThreshold = async (parameter:string) => {
  try {
    const token = await getAccessToken();
    const response = await fetch(TWS_API_URL+'/customthreshold', {
      method: 'DELETE',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify({ [parameter]: {} }),
    });

    if (!response.ok) {
      throw new Error('Network response was not ok');
    }
  } catch (error) {
    throw new Error('Error deleting user threshold');
  }
};

export const updateSensorEventThresholds = async (thresholdsObject: Object) => {
   try {
      let requestBody = {
        "products" : []
      }
      let paramMapping = {
        "ceilingHeight" : "SENSOR_CEILINGS",
        "visibility" : "SENSOR_VISIBILITY",
        "surfaceWind" : "SENSOR_WINDS",
        "surfaceWindGust": "SENSOR_WINDGUSTS",
        "temperatureHighRange": "SENSOR_TEMPERATURE",
      }
      const hazardUnitMap  = {
        "ft" : "feet",
        "sm" : "SM",
        "kts": "kts",
        "F" : "degrees_f"
      }
      for (let key in paramMapping) {
        if(thresholdsObject.hasOwnProperty(key)){
          let threshold = thresholdsObject[key]
          let [comp, value, units] = threshold["currentHighRisk"] 
          let productBody = {
            "hazard" : paramMapping[key],
            "parameters" : [
              {
                "thresholdUnits": hazardUnitMap[units],
                "comparison": comp,
                "distance": 0,
                "distanceUnits": "miles",
                "threshold": value,
              }
            ]
          }
          requestBody["products"].push(productBody)
        }
      }
      
      const token = await getAccessToken();
      const response = await fetch(TWS_API_URL+'/sensorEventThresholds', {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify(requestBody),
      });  
      return;
    } catch (error) {
      throw new Error('Error updating thresholds for sensor events.');
    }
}

export const fetchUserThresholdsV2 = async () => {
    try {
      const token = await getAccessToken();
      const response = await fetch(TWS_API_URL+'/customThresholdV2', {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        },
      });
  
      if (!response.ok) {
        throw new Error('Network response was not ok');
      }
      const data = await response.json();
      return data;
    } catch (error) {
      throw new Error('Error fetching user thresholds');
    }
};

export const createUserThreshold = async(profileLabel : string) => {
  try {
      const token = await getAccessToken();
      let requestBody = {
        "profile" : profileLabel
      }
      const response = await fetch(TWS_API_URL+'/customThresholdV2', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify(requestBody),
      });    
      
      
      if (!response.ok) {
        if(response?.status == 400){
          let data = await response.json()
          let errorMessage = data.message
          throw new Error(errorMessage)
        }
        else 
          throw new Error('Network response was not ok');
      }
      const data = await response.json();
      return data;
  } catch (error) {    
    throw new Error(error?.message || 'Error creating new threshold');
  }
}

export const updateUserThreshold = async(updatedThreshold : Record<string, any>) => {
  try {
      const token = await getAccessToken();
      const response = await fetch(TWS_API_URL+'/customThresholdV2', {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify(updatedThreshold),
      });    
      
      if (!response.ok) {
        if(response?.status == 400){
          let data = await response.json()
          let errorMessage = data.message
          throw new Error(errorMessage)
        }
        else 
          throw new Error('Network response was not ok');
      }
      const data = await response.json();
      return data;
  } catch (error) {    
    throw new Error(error?.message || 'Error creating new threshold');
  }
}

export const deleteUserThreshold = async(profileLabel : string) => {
  try {
      const token = await getAccessToken();
      const response = await fetch(TWS_API_URL+`/customThresholdV2?profile=${profileLabel}`, {
        method: 'DELETE',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        },
      });    
      
      if (!response.ok) {
        if(response?.status == 400){
          let data = await response.json()
          let errorMessage = data.message
          throw new Error(errorMessage)
        }
        else 
          throw new Error('Network response was not ok');
      }
      const data = await response.json();
      return data;
  } catch (error) {    
    throw new Error(error?.message || 'Error creating new threshold');
  }
}
  
  